var AbstractWS = require("./AbstractWS");

function CallAheadWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.endpoint = ko.observable(null);
  self.method('POST');
  self.name = 'CallAheadWS';


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return self.endpoint();
  });

  // Return self as API
  return self;
};

CallAheadWS.prototype = AbstractWS.prototype;
CallAheadWS.prototype.constructor = CallAheadWS;

module.exports = CallAheadWS
